/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_VerifyInputs */

const cs_portals_verify = /** @type {(inputs: Portals_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřit publikaci`)
};

const en_portals_verify = /** @type {(inputs: Portals_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify publication`)
};

/**
* | output |
* | --- |
* | "Verify publication" |
*
* @param {Portals_VerifyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify = /** @type {((inputs?: Portals_VerifyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_VerifyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify(inputs)
	return cs_portals_verify(inputs)
});